var map = {
	"./": 4701,
	"./AdminBlog": 1678,
	"./AdminBlog.tsx": 1678,
	"./DepartmentArticles": 4465,
	"./DepartmentArticles.tsx": 4465,
	"./DptCard": 1721,
	"./DptCard.tsx": 1721,
	"./MyBlogs": 1367,
	"./MyBlogs.tsx": 1367,
	"./Payment": 3717,
	"./Payment.tsx": 3717,
	"./SuccessPage": 600,
	"./SuccessPage.tsx": 600,
	"./UserBlog": 46,
	"./UserBlog.tsx": 46,
	"./about": 8645,
	"./about.tsx": 8645,
	"./aboutpayment": 4688,
	"./aboutpayment.css": 1526,
	"./aboutpayment.tsx": 4688,
	"./aboutus.css": 2816,
	"./active/[slug]": 147,
	"./active/[slug].tsx": 147,
	"./blogs/[slug]": 4584,
	"./blogs/[slug].tsx": 4584,
	"./category": 8535,
	"./category.tsx": 8535,
	"./contact": 4940,
	"./contact.css": 4875,
	"./contact.tsx": 4940,
	"./create_blog": 6950,
	"./create_blog.tsx": 6950,
	"./departArt.css": 8757,
	"./department.css": 7691,
	"./departments": 5981,
	"./departments.tsx": 5981,
	"./forgot_password": 6957,
	"./forgot_password.tsx": 6957,
	"./index": 4701,
	"./index.tsx": 4701,
	"./login": 4436,
	"./login.tsx": 4436,
	"./payingUser": 822,
	"./payingUser.css": 2616,
	"./payingUser.tsx": 822,
	"./payment.css": 2010,
	"./profile/[slug]": 5949,
	"./profile/[slug].tsx": 5949,
	"./project/[slug]": 8925,
	"./project/[slug].tsx": 8925,
	"./register": 9843,
	"./register.tsx": 9843,
	"./reset_password/[slug]": 3017,
	"./reset_password/[slug].tsx": 3017,
	"./success.css": 2571,
	"./update_blog/[slug]": 4823,
	"./update_blog/[slug].tsx": 4823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2150;